import { render, staticRenderFns } from "./MeShippingList.vue?vue&type=template&id=5187e1c8&"
import script from "./MeShippingList.vue?vue&type=script&lang=js&"
export * from "./MeShippingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports